/* eslint-disable react/display-name */
import React from 'react'

function ConsultorMaisLogoImg() {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.6"
        d="M21.5453 19.3416C21.5453 21.0994 20.1026 22.5244 18.323 22.5244L15.1008 22.5244C13.3212 22.5244 11.8786 21.0994 11.8786 19.3416L11.8786 12.9759L18.323 12.9759C20.1026 12.9759 21.5453 14.4009 21.5453 16.1588L21.5453 19.3416Z"
        fill="white"
      />
      <path
        d="M3.22224 22.5244C1.44265 22.5244 -6.22888e-08 21.0994 -1.39126e-07 19.3416L-2.78252e-07 16.1588C-3.55089e-07 14.4009 1.44265 12.9759 3.22224 12.9759L9.66672 12.9759L9.66672 19.3416C9.66672 21.0994 8.22407 22.5244 6.44448 22.5244L3.22224 22.5244Z"
        fill="white"
      />
      <path
        opacity="0.6"
        d="M0 4.18904C0 2.41619 1.44265 0.979004 3.22224 0.979004L6.44448 0.979004C8.22407 0.979004 9.66672 2.41619 9.66672 4.18904L9.66672 10.6091L3.22224 10.6091C1.44265 10.6091 0 9.17193 0 7.39907L0 4.18904Z"
        fill="white"
      />
      <path
        d="M18.323 0.979004C20.1026 0.979004 21.5453 2.41619 21.5453 4.18904L21.5453 7.39907C21.5453 9.17193 20.1026 10.6091 18.323 10.6091L11.8786 10.6091L11.8786 4.18904C11.8786 2.41619 13.3212 0.979004 15.1008 0.979004L18.323 0.979004Z"
        fill="white"
      />
    </svg>
  )
}

export default React.memo(ConsultorMaisLogoImg)
